/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_HereInputs */

const en_auth_signup_here = /** @type {(inputs: Auth_Signup_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up here`)
};

const es_auth_signup_here = /** @type {(inputs: Auth_Signup_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regístrate aquí`)
};

/**
* | output |
* | --- |
* | "Sign up here" |
*
* @param {Auth_Signup_HereInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_signup_here = /** @type {((inputs?: Auth_Signup_HereInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_HereInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_signup_here(inputs)
	return en_auth_signup_here(inputs)
});